module.exports = __webpack_public_path__ + "static/media/ios-flashlight.198292ce.svg";